import type { AbstractEngine } from "@babylonjs/core";

/**
 * Keeps the render canvas sized to its container and exposes a fullscreen
 * toggle. Kept deliberately tiny — resize/fullscreen is not scene logic.
 */
export class CanvasManager {
  private readonly canvas: HTMLCanvasElement;
  private readonly engine: AbstractEngine;
  private readonly onResize = () => this.engine.resize();

  constructor(canvas: HTMLCanvasElement, engine: AbstractEngine) {
    this.canvas = canvas;
    this.engine = engine;
    window.addEventListener("resize", this.onResize);
  }

  async toggleFullscreen(): Promise<void> {
    if (!document.fullscreenElement) {
      await this.canvas.requestFullscreen();
    } else {
      await document.exitFullscreen();
    }
  }

  dispose(): void {
    window.removeEventListener("resize", this.onResize);
  }
}
